import { extPlatDataRetrieveUseCase } from "@frameworks/web/components/Reports/HoldingReports/di/servicelocator";
import { ExtPlatDataRetriveErrorEnum, EXT_PLAT_DATA_RETRIVE_ERROR, EXT_PLAT_DATA_RETRIVE_HIDE_ERROR, } from "./ExtPlatDataRetrieveReducer";
export const ExtPlatDataRetrieveThunks = (token) => async (dispatch, getState) => {
    dispatch({
        type: EXT_PLAT_DATA_RETRIVE_HIDE_ERROR,
        errorType: ExtPlatDataRetriveErrorEnum.ERROR_DATA,
    });
    extPlatDataRetrieveUseCase.execute({
        onSuccess: (data) => {
            localStorage.setItem("acc_data", data !== "" && data !== null
                ? data
                : localStorage.getItem("acc_data"));
        },
        onError: (error) => {
            // error action
            dispatch({
                type: EXT_PLAT_DATA_RETRIVE_ERROR,
                payload: {
                    errorData: error,
                },
                errorType: ExtPlatDataRetriveErrorEnum.ERROR_DATA,
            });
        },
    }, token);
};
